export default __webpack_public_path__ + "static/media/bo.30e99b54.svg";